import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import './ToolPage.css'
import { createRetroBoard } from './utils/retroApiClient'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const RetroBoardCreate = () => {
  useDocumentMeta({
    title: 'Retro de Equipe ao Vivo | jarder.dev',
    description:
      'Quadro de retrospectiva em tempo real: o que foi bom, o que foi ' +
      'ruim e o que melhorar. Cada um posta anônimo e a lista cresce ao ' +
      'vivo pra todo mundo. Serve pra qualquer contexto de grupo, não só time de dev.',
  })

  const history = useHistory()
  const [status, setStatus] = useState('idle')
  const [error, setError] = useState('')

  const create = async () => {
    setStatus('loading')
    setError('')
    try {
      const { id, masterToken } = await createRetroBoard()
      trackEvent('tool_generate', { tool: 'retro_board' })
      history.push(`/ferramentas/retro-ao-vivo/${id}/mestre#token=${masterToken}`)
    } catch {
      setError('Não foi possível criar o quadro agora. Tente novamente.')
      setStatus('idle')
    }
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Retro de Equipe ao Vivo</h1>
      <p className="tool-disclaimer">
        Quadro com três colunas: o que foi bom, o que foi ruim e o que
        melhorar. Qualquer pessoa com o link posta um cartão anônimo em
        qualquer coluna, e todo mundo vê a lista crescer na hora. Não
        precisa estar preso a Scrum, serve pra qualquer reunião de grupo.
      </p>

      <button type="button" className="tool-button" onClick={create} disabled={status === 'loading'}>
        {status === 'loading' ? 'Criando quadro...' : 'Criar quadro'}
      </button>

      {error && <p className="tool-error">{error}</p>}

      <div className="tool-info-section">
        <h2>Como funciona</h2>
        <p>
          Ao criar, você vai pra tela de mestre, só você tem acesso a
          ela. Lá tem um link separado pra compartilhar com o grupo.
        </p>
        <p>
          Os cartões são completamente anônimos: não tem nome, login nem
          identificação de quem escreveu. Como mestre, você pode excluir
          um cartão se precisar moderar algo.
        </p>
      </div>
    </div>
  )
}

export default RetroBoardCreate
